import DocumentDetailField from "./DocumentDetailField";
import DocumentDetailSection from "./DocumentDetailSection";
import DocumentDetailSignSection from "./DocumentDetailSignSection";
import DocumentDetailSubSection from "./DocumentDetailSubSection";
import DocumentDetailTags from "./DocumentDetailTags";
import DocumentDetailFieldValue from "./value/DocumentDetailFieldValue";
import DocumentDetailDescription from "./DocumentDetailDescription";
import DocumentDetailTable from "./DocumentDetailTable";
import DocumentDetailEditorViewer from "./DocumentDetailEditorViewer";
import DocumentDetailFooter from "./DocumentDetailFooter";
import DocumentDetailAttachmentList from "./DocumentDetailAttachmentList";
import DocumentDetailViewerAttachmentList from "./DocumentDetailViewerAttachmentList";
import DocumentDetailCheckBox from "./DocumentDetailCheckBox";
import DocumentDetailComment from "./DocumentDetailComment";

const DocumentDetail = {
  Section: DocumentDetailSection,
  SubSection: DocumentDetailSubSection,
  Description: DocumentDetailDescription,
  Field: DocumentDetailField,
  Value: DocumentDetailFieldValue,
  Tags: DocumentDetailTags,
  SignSection: DocumentDetailSignSection,
  Table: DocumentDetailTable,
  EditorViewer: DocumentDetailEditorViewer,
  AttachmentList: DocumentDetailAttachmentList,
  ViewerAttachmentList: DocumentDetailViewerAttachmentList,
  Footer: DocumentDetailFooter,
  CheckBox: DocumentDetailCheckBox,
  Comment: DocumentDetailComment,
};

export default DocumentDetail;
